export default __webpack_public_path__ + "static/media/booking.5fabb303.png";